<template>
  <div id="dashboard_index" style="margin-top: 20px;">
    <el-row :gutter="20" v-cloak>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header">
            <span style="color: #20A0FF;"><i class="fa fa-dashboard"></i>{{$t('index.terStatus')}}</span>
            <router-link to="/terList"><span class="more">{{$t('index.more')}}</span></router-link>
          </div>
          <el-row :gutter="20" v-if="devData">
            <el-col :lg="8" :xs="24" :sm="8" :md="8">
              <div class="el-card-radio green" @click="jumpTerminal(1)">
                <div class="fl">
                  <img src="../../assets/images/dashboard/online_dev.png"/>
                </div>
                <div class="context">
                  <p class="count">{{devData.zx}}{{$t('index.t')}}</p>
                  <p class="name">{{$t('index.onlineTer')}}</p>
                </div>
              </div>
            </el-col>
            <el-col :lg="8" :xs="24" :sm="8" :md="8" >
              <div class="el-card-radio orange" @click="jumpTerminal(2)">
                <div class="fl">
                  <img src="../../assets/images/dashboard/offline_dev.png"/>
                </div>
                <div class="context">
                  <p class="count">{{devData.lx}}{{$t('index.t')}}</p>
                  <p class="name">{{$t('index.offLineTer')}}</p>
                </div>
              </div>
            </el-col>
            <el-col :lg="8" :xs="24" :sm="8" :md="8" >
            <div class="el-card-radio pink" @click="jumpTerminal(null)">
              <div class="fl">
                <img src="../../assets/images/dashboard/warn_dev.png"/>
              </div>
              <div class="context">
                <p class="count">{{devData.yj}}{{$t('index.t')}}</p>
                <p class="name">{{$t('index.warnTer')}}</p>
              </div>
            </div>
          </el-col>
          </el-row>
        </el-card>




        <el-card class="box-card" v-cloak v-if="taskData">
          <div slot="header">
            <span style="color: #20A0FF;"><i class="fa fa-list-ol"></i>{{$t('index.taskList')}}</span>
            <router-link to="/mision-list"><span class="more">{{$t('index.more')}}</span></router-link>
          </div>
          <el-row :gutter="20">
            <el-col :lg="8" :xs="24" :sm="8" :md="8">
              <div class="el-card-radio blue" @click="jump('/task/ptask')">
                <div class="fl">
                  <img src="../../assets/images/dashboard/app_push.png"/>
                </div>
                <div class="context">
                  <p class="count">{{taskData.yy}}</p>
                  <p class="name">{{$t('index.pullApp')}}</p>
                </div>
              </div>
            </el-col>
            <el-col :lg="8" :xs="24" :sm="8" :md="8">
              <div class="el-card-radio blue let" @click="jump('/task/ptask')">
                <div class="fl">
                  <img src="../../assets/images/dashboard/rom_update.png"/>
                </div>
                <div class="context">
                  <p class="count">{{taskData.rom}}</p>
                  <p class="name">{{$t('index.romUpdate')}}</p>
                </div>
              </div>
            </el-col><el-col :lg="8" :xs="24" :sm="8" :md="8">
            <div class="el-card-radio green let" @click="jump('/task/ptask')">
              <div class="fl">
                <img src="../../assets/images/dashboard/ad_push.png"/>
              </div>
              <div class="context">
                <p class="count">{{taskData.gg}}</p>
                <p class="name">{{$t('index.pullAdvert')}}</p>
              </div>
            </div>
          </el-col>
          </el-row>
        </el-card>




        <el-card class="box-card" v-cloak v-if="infoData">
          <div slot="header">
            <span style="color: #20A0FF;"><i class="fa fa-file-text-o"></i>{{$t('index.infoList')}}</span>
            <router-link to="/warn"><span class="more">{{$t('index.more')}}</span></router-link>
          </div>
          <el-row :gutter="20">
            <el-col :lg="12" :xs="24" :sm="12" :md="12">
              <div class="el-card-radio pink dark" @click="jump('/warn')">
                <div class="fl">
                  <img src="../../assets/images/dashboard/rish_warn.png"/>
                </div>
                <div class="context">
                  <p class="count">{{infoData.fk}}</p>
                  <p class="name">{{$t('index.riskWarn')}}</p>
                </div>
              </div>
            </el-col>
            <el-col :lg="12" :xs="24" :sm="12" :md="12">
              <div class="el-card-radio orange dark" @click="jump('/warn')">
                <div class="fl">
                  <img src="../../assets/images/dashboard/stoppage_warn.png"/>
                </div>
                <div class="context">
                  <p class="count">{{infoData.gz}}</p>
                  <p class="name">{{$t('index.breakWarn')}}</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  export default{
    data(){
      return {
      	token: localStorage.getItem("user") | null,
      	devData: null,
        taskData: null,
        infoData: null
      }
    },
    compted: {
      getRandTime () {
        return new Date().getTime();
      }
    },
    methods: {
    	// 跳转设备列表 , 且附带筛选参数
      jumpTerminal (code) {
      	if (code) {
          this.$store.dispatch('setParam',code)
        } else {
          this.$store.dispatch('setParam',null)
        }

      	var url = "/terList"
        this.$router.push({path: url})
      },
      // 根据传入的uri跳转到指定页面
      jump (uri) {
        this.$router.push({path: uri})
      },
    	fetchData () {
        var that = this
        that.fetchDevData()
        that.fetchTaskData()
        that.fetchInfoData()
      },
      fetchDevData() {
    		var that = this
        axios.post(`${baseurl}/home/terminalsStatus.do`,{distributorId: localStorage.getItem('mechanismId'), token: that.token}).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.devData = res.data.data
          }
        })
      },
      fetchTaskData() {
        var that = this
        axios.post(`${baseurl}/home/taskStatus.do`,{distributorId: localStorage.getItem('mechanismId'), token: that.token}).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.taskData = res.data.data
          }
        })
      },
      fetchInfoData() {
        var that = this
        axios.post(`${baseurl}/home/riskStatus.do`,{distributorId: localStorage.getItem('mechanismId'), token: that.token}).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.infoData = res.data.data
          }
        })
      }
    },
    mounted () {
      this.fetchData()
    }
  }
</script>
<style scoped>
  [v-cloak] {
    display: none;
  }
	.box-card{
		width: 100%;
    margin-bottom: 20px;
  }
	.more {
    float: right;
    font-size: 16px;
  }
  /* 卡片覆盖样式 edit: mao */
  .el-card__header .more {
    font-size: 14px;
  }
  .el-card__header i {
    margin-right: .3rem;
  }
  .el-card-radio{
    height: 80px;
    border-radius: 8px;
    border: 1px solid red;
    cursor: pointer;
  }

  .el-card-radio .context {
    float:right;padding:8px 16px;text-align: right;
  }

  .el-card-radio div img{
    height:100%;border:none;padding:0;margin:0;width:110px;
  }

  .el-card-radio .context>.count {
    font-size: 32px;
    color: #767676;
    margin-bottom: 10px;
  }
  .el-card-radio .context>.name {
    color:#C1C2C8;font-size: 14px;
  }
  .el-card-radio.green{
    border-color: #4ec19a;
  }
  .el-card-radio.green.let{
    border-color: #75cbc9;
  }
  .el-card-radio.orange{
    border-color: #efba40;
  }

  .el-card-radio.orange.dark{
    border-color: #fd805e;
  }

  .el-card-radio.pink{
    border-color: #f87984;
  }

  .el-card-radio.pink.dark{
    border-color: #fd8179;
  }

  .el-card-radio.blue{
    border-color: #2caad6;
  }

  .el-card-radio.blue.let{
    border-color: #67c2dc;
  }

  .el-row .el-col{
    margin-bottom: 20px;
  }
  /* 卡片覆盖样式 end */
</style>



// WEBPACK FOOTER //
// index.vue?537d1b90